import {DB_DICT_DATA_KEY} from "../../enums/cacheEnum";
import { queryAllDictItems } from "../../api/dictionary.js";
import { getAuthCache, setAuthCache } from "../../utils/auth";

const dictionaryStore = {
    state: {
        dictItems: null
    },
    mutations: {
        setAllDictItems(state, dictItems) {
            state.dictItems = dictItems;
            setAuthCache(DB_DICT_DATA_KEY, dictItems);
        },
        setAllDictItemsByLocal(state) {
            if (!state.dictItems) {
                const allDictItems = getAuthCache(DB_DICT_DATA_KEY);
                if (allDictItems) {
                    state.dictItems = allDictItems;
                }
            }
        },
    },
    actions: {
        async loadDictionary({ commit,state }){
            const sysAllDictItems=await queryAllDictItems();
            if (sysAllDictItems) {
                commit("setAllDictItems", sysAllDictItems.result);
                state.dictItems = sysAllDictItems.result;
            }    
        }
    },
    getters: {
        getAllDictItems(state) {
            return state.dictItems || getAuthCache(DB_DICT_DATA_KEY);
        }
    }
}

export default dictionaryStore;
